import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ForgotPINLazy = lazyLoader(
  () => import('./ForgotPin' /* webpackChunkName: "forgot-pin" */),
);

const ForgotPin = () => {
  return (
    <Suspense fallback={null}>
      <ForgotPINLazy />
    </Suspense>
  );
};

export default ForgotPin;
